var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.796889 3.98444V13.9456C0.796889 14.1655 0.975392 14.344 1.19533 14.344H10.758C10.9779 14.344 11.1564 14.1655 11.1564 13.9456V3.98444H11.5549C11.7748 3.98444 11.9533 3.80594 11.9533 3.586V1.99222C11.9533 1.77228 11.7748 1.59378 11.5549 1.59378H7.96889V0.398444C7.96889 0.178503 7.79039 0 7.57044 0H4.38289C4.16295 0 3.98444 0.178503 3.98444 0.398444V1.59378H0.398444C0.178503 1.59378 0 1.77228 0 1.99222V3.586C0 3.80594 0.178503 3.98444 0.398444 3.98444H0.796889ZM10.2214 13.3946H1.73189V4.13508H10.2214V13.3946ZM4.78133 0.796889H7.172V1.59378H4.78133V0.796889ZM0.796889 2.37976H11.1552V3.20476H0.796889V2.37976Z",
    fill: "#D62B2B",
    fillOpacity: 0.983639
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76279 11.5958V5.82083C3.76279 5.64373 3.53068 5.5 3.24468 5.5C2.95868 5.5 2.72656 5.64373 2.72656 5.82083V11.5958C2.72656 11.7729 2.95868 11.9167 3.24468 11.9167C3.53068 11.9167 3.76279 11.7729 3.76279 11.5958Z",
    fill: "#D62B2B",
    fillOpacity: 0.983639
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7042 11.5958V5.82083C8.7042 5.64373 8.47208 5.5 8.18608 5.5C7.90008 5.5 7.66797 5.64373 7.66797 5.82083V11.5958C7.66797 11.7729 7.90008 11.9167 8.18608 11.9167C8.47208 11.9167 8.7042 11.7729 8.7042 11.5958Z",
    fill: "#D62B2B",
    fillOpacity: 0.983639
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15342 11.5958V5.82083C6.15342 5.64373 5.9213 5.5 5.6353 5.5C5.3493 5.5 5.11719 5.64373 5.11719 5.82083V11.5958C5.11719 11.7729 5.3493 11.9167 5.6353 11.9167C5.9213 11.9167 6.15342 11.7729 6.15342 11.5958Z",
    fill: "#D62B2B",
    fillOpacity: 0.983639
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9533,
    height: 14.344,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.8ccc1313027f24fd141c4fce3ec4133c.svg";
export { ForwardRef as ReactComponent };